import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
} from '@mui/material';
import { useState } from 'react';
import { useCreateCustomerMutation } from 'src/backend';
import LoadingButton from 'src/components/LoadingButton';

export type CreateCustomerRequest = {
  name: string;
};

interface CreateCustomerDialogProps {
  open: boolean;
  onClose: () => void;
  onCustomerCreated: () => void;
}

function CreateCustomerDialog({
  open,
  onClose,
  onCustomerCreated,
}: CreateCustomerDialogProps) {
  const [newCustomer, setNewCustomer] = useState({
    name: '',
  });

  const [createCustomer, { isLoading: isCreatingCustomer }] =
    useCreateCustomerMutation();

  const handleAddCustomer = () => {
    const request: CreateCustomerRequest = {
      name: newCustomer.name,
    };

    createCustomer(request)
      .unwrap()
      .then(() => {
        onCustomerCreated();
        onClose();
        setNewCustomer({
          name: '',
        });
      });
  };

  const handleClose = () => {
    onClose();
    setNewCustomer({
      name: '',
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ padding: '2rem', fontSize: '2.5rem' }}>
        Add New Customer
      </DialogTitle>
      <DialogContent sx={{ padding: '2rem' }}>
        <Stack spacing={3}>
          <TextField
            label="Name"
            value={newCustomer.name}
            onChange={(e) =>
              setNewCustomer((prev) => ({ ...prev, name: e.target.value }))
            }
            fullWidth
            required
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <LoadingButton
          loading={isCreatingCustomer}
          variant="contained"
          onClick={handleAddCustomer}
          disabled={!newCustomer.name}
        >
          Add Customer
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}

export default CreateCustomerDialog;
